const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgKeyProtect(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 250 250",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("circle", {
    cx: 125,
    cy: 125,
    r: 125,
    style: {
      fill: "#f7f7f7"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 125,
    cy: 125,
    r: 100.35,
    style: {
      fill: "#efefef"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M125,37,53,69v48c0,44.42,30.73,86,72,96,41.3-10.08,72-51.62,72-96V69Z",
    style: {
      fill: "#282830"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M114.3,125.21a17.81,17.81,0,1,0,8.4,8.39l21.71-21.7,8.4,8.39,8.39-8.39-8.39-8.4L157,99.3l-8.39-8.4Zm-3.48,20.28a5.94,5.94,0,1,1,0-8.4A6,6,0,0,1,110.82,145.49Z",
    style: {
      fill: "#fff"
    }
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgKeyProtect);
export default __webpack_public_path__ + "static/media/keyProtect.d7831f66.svg";
export { ForwardRef as ReactComponent };